import Header from "~/components/ui/SectionHeader"
import type { ImageWidget } from "~/types/widgets"
import Image from "~/components/ui/Image"
import { useMemo } from "react"

/**
 * @titleBy altText
 */
export interface Image {
    /**
     * @title Imagem
     */
    image: ImageWidget
    /**
     * @title Texto alternativo
     */
    altText: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string
    /**
     * @title Descrição
     */
    description?: string
    /**
     * @title Imagens
     */
    images?: Image[]
    layout?: {
        /**
         * @title Alinhamento do cabeçalho
         */
        headerAlignment?: 'center' | 'left'
    }
}

const IMAGES = [
    {
        altText: 'deco',
        image:
            'https://decoims.com/miess-01/238974bd-a124-4f12-ac00-7042f20f44e1/fe7cd8ba-c954-45d6-9282-ee7d8ca8e3c7.jpg',
    },
    {
        altText: 'deco',
        image:
            'https://decoims.com/miess-01/0e536143-145d-4b5e-95be-9464f0ece0a9/637e8601-6b86-4979-aa97-68013a2a60fd.jpg',
    },
]

function Logos(props: Props) {
    const { title, description, images, layout } = props
    const list = useMemo(
        () =>
            images && images.length > 0 ? images : Array(20)
                .fill(null)
                .map((_, i) => IMAGES[i % 2]),
        [],
    )

    return (
        <div className='w-full container px-4 py-8 flex flex-col gap-8 lg:gap-12 lg:py-10 lg:px-0'>
            <Header
                title={title}
                description={description}
                alignment={layout?.headerAlignment || 'center'}
            />
            <div className='w-full text-center items-center'>
                {list.map((element) => (
                    <div className='w-36 lg:w-40 h-17 lg:h-20 px-4 lg:px-6 py-6 lg:py-4 inline-block align-middle'>
                        <div className='flex w-full h-full items-center justify-center'>
                            <Image
                                width={300}
                                height={300}
                                src={element.image}
                                alt={element.altText || ''}
                                className='max-w-full max-h-full'
                                loading='lazy'
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Logos
export { default as LoadingFallback } from "~/components/LoadingFallback"
